import { Notification as WebSDKNotification } from '@zambezi/sdk/notification';
import React from 'react';
import './Notification.scss';

type NotificationVariant = 'info' | 'error' | 'warning' | 'success';

interface NotificationProps {
  title?: string;
  children: React.ReactNode | React.ReactNode[];
  variant?: NotificationVariant;
}

const Notification = ({ children, variant = 'info', title }: NotificationProps) => {
  return (
    <WebSDKNotification
      title={title}
      status={variant}
      withBackground={false}
      iconProps={{ title: '' }}
      className="mss-notification"
    >
      {children}
    </WebSDKNotification>
  );
};

export default Notification;
